const noviqdistribution = {
    id: 'noviqdistribution',
    publicSiteName: 'Noviq Distribution',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#0f9908',
            secondary: '#121818',
            color1: '#1dd613',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/noviqdistribution/favicon.ico',
        logo: '/noviqdistribution/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
    pricing: {
        showVatBreakdown: true,
        vatDisplayFormat: 'both',
    },

}

export default noviqdistribution